/**
 * Chat domain helpers for shared realtime.
 * Does NOT own the WebSocket lifecycle.
 */

export function isChatChannel(payload) {
  const channel = String((payload && payload.channel) || "").toLowerCase();
  const eventName = String((payload && payload.event) || "")
    .replace(/^\./, "")
    .toLowerCase();
  if (channel.indexOf("chat.") === 0) {
    return true;
  }
  return eventName.indexOf("chat.") === 0 || eventName.indexOf("chat_") === 0;
}

export function normalizeChatEventName(payload) {
  var eventName = String((payload && payload.event) || "").replace(/^\./, "");
  var data = payload && payload.data != null ? payload.data : null;
  if (data && typeof data === "object" && data.action) {
    return String(data.action).replace(/^\./, "");
  }
  return eventName;
}

export function chatListChannelName(abr) {
  return abr != null && abr !== "" ? "chat." + abr : null;
}

export function chatRoomChannelName(abr, chatId) {
  if (abr == null || abr === "" || chatId == null || chatId === "") {
    return null;
  }
  return "chat." + abr + "." + chatId;
}

/**
 * Subscribe the customer chat-list channel.
 * @returns {Function} unsubscribe
 */
export function subscribeChatList(realtime, abr) {
  var channel = chatListChannelName(abr);
  if (!realtime || !channel) {
    return function () {};
  }
  realtime.subscribe(channel);
  return function unsubscribe() {
    realtime.unsubscribe(channel);
  };
}

/**
 * Chat-room subscribe helpers bound to one abr on a shared connection.
 */
export function createChatRoomSubscriptions(realtime, abr) {
  var roomChannels = {};

  return {
    subscribeChatRoom: function (chatId) {
      var channel = chatRoomChannelName(abr, chatId);
      if (!realtime || !channel) {
        return;
      }
      if (roomChannels[channel]) {
        return;
      }
      roomChannels[channel] = true;
      realtime.subscribe(channel);
    },
    unsubscribeChatRoom: function (chatId) {
      var channel = chatRoomChannelName(abr, chatId);
      if (!realtime || !channel || !roomChannels[channel]) {
        return;
      }
      delete roomChannels[channel];
      realtime.unsubscribe(channel);
    },
    clear: function () {
      roomChannels = {};
    },
  };
}
